import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-width": "1.75",
      d: "M8.35 5.65h7.3a1.9 1.9 0 0 1 1.9 1.9v8.9a1.9 1.9 0 0 1-1.9 1.9h-7.3a1.9 1.9 0 0 1-1.9-1.9v-8.9a1.9 1.9 0 0 1 1.9-1.9Z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.75",
      d: "M9.3 8.95h5.4m-5.4 2.7h5.4M10.85 15.2h2.3"
    }, null, -1)
  ]))]))
}
export default { render: render }